/**
 * Design tokens for both admin (control room) and public sites.
 * SHARED with backend SSR — backend reads /app/frontend/src/lib/design_tokens.json directly.
 * Keep additions in JSON only.
 */
import tokens from "./design_tokens.json";

export const PALETTES = tokens.palettes;
export const FONT_PAIRS = tokens.font_pairs;

export const TEMPLATES = [
  {
    key: "tribune",
    name: "Tribune",
    tagline: "Classic newspaper, dense columns, serif headlines.",
    bestFor: "General US news, finance, policy",
    preview:
      "https://images.unsplash.com/photo-1623039405147-547794f92e9e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxuZXdzcGFwZXIlMjBsYXlvdXR8ZW58MHx8fHwxNzgwODQ4NTM1fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    key: "terminal",
    name: "Terminal",
    tagline: "Bloomberg/FT-inspired finance dashboard, ticker bar, dense data.",
    bestFor: "Finance-heavy, markets, trading",
    preview:
      "https://images.unsplash.com/photo-1550745165-9bc0b252726f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxyZXRybyUyMGNvbXB1dGVyJTIwdGVybWluYWx8ZW58MHx8fHwxNzgwODQ4NTM2fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    key: "brief",
    name: "Brief",
    tagline: "Modern editorial magazine, large heroes, generous whitespace.",
    bestFor: "Lifestyle finance, explainers, curated",
    preview:
      "https://images.unsplash.com/photo-1609605348579-3123e3d40eb8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwdHlwb2dyYXBoeSUyMGxheW91dHxlbnwwfHx8fDE3ODA4NDg1MzZ8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const VARIANTS = {
  tribune: [
    { key: "v1", name: "Broadsheet", note: "5-column dense grid, no hero" },
    { key: "v2", name: "Magazine", note: "Massive hero + 3-up grid" },
    { key: "v3", name: "Wire", note: "Ticker + 2-column lead" },
  ],
  terminal: [
    { key: "v1", name: "Mainframe", note: "Mono headlines, ticker rail" },
    { key: "v2", name: "Trading Floor", note: "Tables + data tiles" },
    { key: "v3", name: "Quiet Mono", note: "Minimal mono, single column" },
  ],
  brief: [
    { key: "v1", name: "Editorial", note: "Large hero + pull quotes" },
    { key: "v2", name: "Curated", note: "Asymmetric grid, picks of the week" },
    { key: "v3", name: "Whitespace", note: "Minimal, single-feature focus" },
  ],
};

export const VOICES = [
  { key: "punchy-retail", label: "Punchy Retail Trader", note: "Casual, tradeable angle, second-person" },
  { key: "wire-service-neutral", label: "Wire Service Neutral", note: "AP/Reuters style, factual, terse" },
  { key: "analytical-explainer", label: "Analytical Explainer", note: "Deeper context, calm authority" },
  { key: "breaking-fast", label: "Breaking Fast", note: "Lead-heavy, 5W1H, active verbs" },
  { key: "casual-blog", label: "Casual Blog", note: "Conversational, light humor" },
];
